import { EventTags } from "../../data";
export const FilterFunctions = {
    /**
     * Check if entity is from selected sportIds
     * @param {Entity} x
     * @param {string[]} sportIds
     */
    filterBySport(x, sportIds) {
        return sportIds.indexOf(x.sportId) > -1;
    },
    /**
     * Check if event has liveStream
     * @param {iEvent} x
     */
    filterByLiveStream(x) {
        return this.filterByTag(x, EventTags.LiveStreaming.toString());
    },
    /**
     * Check if event has specific tag
     * @param {iEvent} x
     * @param {String} tag
     */
    filterByTag(x, tag) {
        return x.tags.indexOf(tag) > -1;
    },
    /**
     * Check if Event or Market is in this date/time range
     * @param {iEvent|iMarket} x
     * @param {string[]} sportIds
     * @param {Date} from
     * @param {Date} to
     */
    filterBySportAndDate(x, sportIds, from, to) {
        var eventDateTime = new Date(x.startEventDate || x.startDate);
        return this.filterBySport(x, sportIds) && (eventDateTime >= from && eventDateTime < to);
    },
    /**
     * Check if event is in favourites
     * @param {iEvent} x
     * @param {string[]} eventIds
     */
    filterByFavorites(x, eventIds) {
        return eventIds.indexOf(x.id) > -1;
    },
    /**
     * Check if market is from specific market types
     * @param {iMarket} x
     * @param {string[]} marketTypes
     */
    filterByMarketType(x, marketTypes) {
        return marketTypes.indexOf(x.marketType.id) > -1;
    }
};
//# sourceMappingURL=FilterFunctions.js.map